module.exports = __webpack_public_path__ + "img/grey_057.6b74efa2.png";